import { makeStyles } from '@material-ui/core';
import { createStyles } from '@material-ui/core/styles';
import typography from 'theme/typography';

const searchSelectValueStyles = makeStyles(theme => createStyles({
  chipActive: {
    ...typography.caption,
    background: theme.palette.gradients.brandingMain,
    color: theme.palette.white,
    height: 20,
    width: 20,
    marginLeft: theme.spacing(1),
    '& > .MuiChip-label': {
      paddingLeft: 0,
      paddingRight: 0,
      textOverflow: 'unset',
      display: 'block',
      width: '100%',
      textAlign: 'center',
    },
  },
}));

export default searchSelectValueStyles;
